import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
    Drawer, Box, Button, Divider, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import headerMessages from './message/HeaderMessage';
import PersonIcon from '../primitive/icons/personIcon';




const SsoUserDrawer = ({
    intl, firstName, fullName, loyaltyNumber, onLogout
}) => {
    const [openDrawer, setOpenDrawer] = useState(false);

    return (
        <div className='sso-user-drawer-wrapper'>
            <IconButton
                className='sso-account-button'
                aria-label={intl.formatMessage(headerMessages.accountMenu)}
                aria-haspopup='dialog'
                aria-expanded={openDrawer}
                disableRipple
                onClick={() => setOpenDrawer(true)}
            >
                <PersonIcon />
                {firstName && <span className='sso-account-name'>{firstName}</span>}
            </IconButton>
            <Drawer
                anchor='right'
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                PaperProps={{
                    role: 'dialog',
                    'aria-label': intl.formatMessage(headerMessages.accountMenu),
                    'aria-modal': 'true',
                    className: 'sso-drawer-paper'
                }}
            >
                <Box className='sso-drawer-content'>
                    <Box className='sso-drawer-header'>
                        <Box className='sso-drawer-identity'>
                            <PersonIcon className='sso-drawer-identity-icon' />
                            <span className='sso-drawer-name'>{fullName || firstName}</span>
                        </Box>
                        <IconButton
                            className='sso-drawer-close'
                            aria-label='Close'
                            onClick={() => setOpenDrawer(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Divider className='sso-drawer-divider' />
                    {loyaltyNumber && (
                        <Box className='sso-drawer-loyalty'>
                            <div className='sso-drawer-loyalty-label'>
                                {intl.formatMessage(headerMessages.loyaltyNumber)}
                            </div>
                            <div className='sso-drawer-loyalty-value'>
                                {loyaltyNumber}
                            </div>
                            <Divider className='sso-drawer-divider' />
                        </Box>
                    )}
                    <Button
                        className='sso-drawer-logout'
                        variant='text'
                        disableRipple
                        onClick={() => {
                            setOpenDrawer(false);
                            onLogout();
                        }}
                    >
                        {intl.formatMessage(headerMessages.logout)}
                    </Button>
                </Box>
            </Drawer>
        </div>
    );
};

SsoUserDrawer.defaultProps = {
    firstName: null,
    fullName: null,
    loyaltyNumber: null
};

SsoUserDrawer.propTypes = {
    intl: intlShape.isRequired,
    firstName: PropTypes.string,
    fullName: PropTypes.string,
    loyaltyNumber: PropTypes.string,
    onLogout: PropTypes.func.isRequired
};

export default injectIntl(SsoUserDrawer);
